<template>
  <div>
    <button
      class="accordion text-grey-draft-dark tw-font-semibold"
      :class="{ active: active }"
      type="button"
      @click="onClick"
    >
      <span>{{ title }}</span>
    </button>
    <div ref="panel" class="panel tw-bg-transparent" :style="panelStyle">
      <div class="text-grey-draft-dark tw-pb-[18px]" v-html="content"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const panel = ref(null);
const active = ref(false);

defineProps({
  title: {
    type: String,
    required: true,
  },

  content: {
    type: String,
    required: true,
  },
});

const panelStyle = computed(() => {
  return {
    maxHeight: active.value ? panel.value.scrollHeight + 'px' : null,
  };
});

const onClick = () => {
  active.value = !active.value;
};
</script>
